import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

export default class VendortTemplateAPI {
  static getHeaderData() {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetGeneratorVendorHeader,
      'GET',
      AppConstants.APP_BACKEND_HOST_KEY   //undo this and use method callAzureFunction while checking in
    );
  }
  
  static getScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetGeneratorVendorData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,   //undo this and use method callAzureFunction while checking in
      data
    );
  }
  
  static updateVendorScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.UpdateVendorData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  
  
}
